import { render } from "./Layout.vue?vue&type=template&id=b8212d8a&scoped=true&ts=true"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"

import "./Layout.vue?vue&type=style&index=0&id=b8212d8a&lang=scss&scoped=true"
import "./Layout.vue?vue&type=style&index=1&id=b8212d8a&lang=scss"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8212d8a"]])

export default __exports__